<style>
	.loader {
		margin: -5px 0 0 35px;
        position: fixed;
		border: 12px solid var(--danger);
		border-top: 12px solid #f3f3f3;
		border-radius: 50%;
		width: 15px;
		height: 15px;
		animation: spin 2s linear infinite;
	}

	@keyframes spin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
	}

    .notification-counter {
        background: var(--danger);
        /* min-width: 25px;
        min-height: 25px; */
		width: 25px;
		height: 25px;
        border-radius: 50%;
        text-align: center;
        margin: -5px 0 0 35px;
        position: fixed;
        color: white;
        font-weight: bold;
        padding-top: 4px;
        font-size: 12px;
    }
    .navigation-collapsed {
        margin: -30px 0 0 25px !important;
    }
    .close-notifications {
        padding: 15px;
        color: white;
        font-size: 25px;
	}
	.sidebar-collapse {
		display: flex;
    	flex-direction: column;
	}
	/* A definite height lets the assistant pane claim the leftover space via flex. */
	.sidebar-collapse--assistant {
		height: 100vh;
	}
	.sidebar-mode-switch {
		display: flex;
		gap: 4px;
		padding: 8px 12px 10px;
	}
	.sidebar-mode-switch__btn {
		flex: 1;
		padding: 6px 8px;
		border: 1px solid #3d5266;
		border-radius: 3px;
		background: transparent;
		color: #a7b1c2;
		font-size: 12px;
		font-weight: 600;
	}
	.sidebar-mode-switch__btn:hover {
		color: #ffffff;
	}
	.sidebar-mode-switch__btn--active {
		background: #1ab394;
		border-color: #1ab394;
		color: #ffffff;
	}
	.sidebar-mode-switch__btn i {
		margin-right: 5px;
	}
	.sidebar-mode-icon {
		margin: 8px auto 10px;
		width: 40px;
		height: 34px;
		border: 1px solid #3d5266;
		border-radius: 3px;
		background: transparent;
		color: #a7b1c2;
		font-size: 16px;
	}
	.sidebar-mode-icon:hover {
		color: #ffffff;
	}
	.sidebar-assistant {
		display: flex;
		flex-direction: column;
		flex: 1 1 auto;
		min-height: 0;
		background: #2f4050;
		border-top: 1px solid #3d5266;
	}
	/* metisMenu writes inline display on #side-menu, so hiding it needs to outrank that. */
	.sidebar-pane-hidden {
		display: none !important;
	}
</style>

<nav class="navbar-default navbar-static-side" role="navigation">
	<div class="sidebar-collapse" [class.sidebar-collapse--assistant]="assistantActive" [style.maxHeight.px]="getPageHeight()">
		<div  [style.background-color]="env=='QA' ? '#E1341E' :  env=='DEV' ? '#AC1664' :env=='STAGE' ? '#31B88D' :env=='UAT' ? '#74970B' :  env=='HOTFIX' ? '#a626d9' :'#293846'"  style="width: 100%;text-align: right;">
			<a class="btn btn-primary" (click)="toggleNavigation()" style="margin: 1em;"><i class="fa fa-bars"></i> </a>
		</div>
		<ul class="nav metismenu" id="side-menu-account">
			<li class="nav-header" style="padding-top: 1em;">
				<div class="profile-element" dropdown>
					<div class="notification-counter"
						(click)="toggleNotifications()"
						*ngIf="notificationCount > 0"
						[@notificationCounterChange]="notificationCount">
						<span *ngFor="let notificationCount of [ notificationCount ]">{{ notificationCount }}</span>
					</div>
					<div *ngIf="!isNotificationFetched && sfhAuth.isAuthenticated()" class="loader">
					</div>
					<img *ngIf="sfhAuth.isAuthenticated()" alt="image" class="img-circle" src="assets/images/default-person.png" style="width: 48px;" (click)="toggleNotifications()">
					<label *ngIf="env!=='PROD'"
						[style.background-color]="env=='QA' ? '#E1341E' :  env=='DEV' ? '#AC1664' :env=='STAGE' ? '#31B88D' :env=='UAT' ? '#74970B' :  env=='HOTFIX' ? '#a626d9' :'#293846'"
						style="margin-left: 20px;font-weight: bold;">
						<span style="padding-left: 7px;padding-right: 7px;font-size: 20px;color: #ffffff;">{{env}}</span>
					</label>
					<a *ngIf="sfhAuth.isAuthenticated()" dropdownToggle>
						<span class="block m-t-xs"> <strong class="font-bold">{{userInfo?.fullName}}</strong> </span>
					</a>
					<ul class="animated fadeInRight dropdown-menu" *dropdownMenu>
						<li><a href="#">Profile</a></li>
						<li><a href="#">Contacts</a></li>
						<li><a [routerLink]="['/category-Notification']">Notification</a></li>
						<li><a href="#">Environment: <b>{{env}}</b></a></li>
						<li class="divider"></li>
						<li (click)="logout()"><a href="#"><i class="fa fa-sign-out" ></i> Logout</a></li>
					</ul>
				</div>
				<div class="logo-element">
					<div class="notification-counter navigation-collapsed" 
						(click)="toggleNotifications()" 
						*ngIf="notificationCount > 0"
						[@notificationCounterChange]="notificationCount">
						<span *ngFor="let notificationCount of [ notificationCount ]">{{ notificationCount }}</span>
					</div>
					CFCL
				</div>
			</li>
		</ul>
		<div class="sidebar-mode-switch" *ngIf="canUseAIChatAssistant && !navCollapsed">
			<button type="button"
				class="sidebar-mode-switch__btn"
				[class.sidebar-mode-switch__btn--active]="!assistantActive"
				[attr.aria-pressed]="!assistantActive"
				(click)="showMenu()">
				<i class="fa fa-bars" aria-hidden="true"></i>Navigation
			</button>
			<button type="button"
				class="sidebar-mode-switch__btn"
				[class.sidebar-mode-switch__btn--active]="assistantActive"
				[attr.aria-pressed]="assistantActive"
				(click)="showAssistant()">
				<i class="fa fa-comments" aria-hidden="true"></i>Assistant
			</button>
		</div>
		<button type="button"
			class="sidebar-mode-icon"
			*ngIf="canUseAIChatAssistant && navCollapsed"
			title="Open assistant"
			(click)="showAssistant()">
			<i class="fa fa-comments" aria-hidden="true"></i>
			<span class="sr-only">Open assistant</span>
		</button>
		<!-- Mounted on first use and then only hidden: the chat transcript lives in
		     AppChatPanelComponent's own signals, so destroying it discards the history. -->
		<div class="sidebar-assistant" *ngIf="canUseAIChatAssistant && assistantLoaded" [class.sidebar-pane-hidden]="!assistantActive">
			<app-chat-panel
				title="Rail360 Chat"
				historyTitle="Conversation History"
				usageLabel="Context"
				pendingLabel="Checking Rail360"
				historyButtonLabel="Conversation history"
				newConversationButtonLabel="Start a new conversation"
				[enableReasoningStream]="canDebugAIChatAssistant">
			</app-chat-panel>
		</div>
		<ul class="nav metismenu" id="side-menu" style="overflow-y: auto;" [class.sidebar-pane-hidden]="assistantActive">
			<li [ngClass]="{'mm-active': activeRoute('starter')}">
				<a [routerLink]="['/starterview']"><i class="fa fa-home"></i> <span class="nav-label">Home</span></a>
			</li>
			<li *ngIf="!sfhAuth.isAuthenticated()" [ngClass]="{'mm-active': activeRoute('login')}">
				<a [routerLink]="['/login']"><i class="fa fa-th-large"></i> <span class="nav-label">Login</span></a>
			</li>
			<li *ngIf="sfhAuth.isAuthenticated()" [ngClass]="{'mm-active': activeRoute('fleet')}">
				<a target="_blank" class="has-arrow"><i class="fa fa-cog"></i> <span class="nav-label">Fleet</span><span class="fa arrow"></span></a>
				<ul class="nav nav-second-level mm-collapse" [routerLinkActive]="['mm-show']">
					<li [ngClass]="{'mm-active': activeRoute('fleet/dashboard')}">
						<a [routerLink]="['/fleet/dashboard']"><i class="fa fa-chart-pie"></i> <span class="nav-label">Dashboard</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('fleet/serviceevent')}">
						<a  [routerLink]="['/fleet/serviceevent/search']"><i class="fa fa-wrench"></i> <span class="nav-label">Service Event</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('fleet/programwork')}">
						<a [routerLink]="['/fleet/programwork/search']"><i class="fa fa-cogs"></i> <span class="nav-label">Program Work</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('fleet/facility')}">
						<a [routerLink]="['/fleet/facility/search']"><i class="fa fa-building"></i><span class="nav-label">Facility</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('fleet/shopportal')}">
						<a target="_blank" class="has-arrow"><i class="fa fa-clock"></i> <span class="nav-label">Shop Portal
							Mgmt</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							<li [ngClass]="{'mm-active': activeRoute('fleet/shopportal/approvals')}">
								<a [routerLink]="['/fleet/shopportal/approvals']"><i class="fa fa-thumbs-up"></i> <span class="nav-label">Approval(s)</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/shopportal/search')}">
								<a [routerLink]="['/fleet/shopportal/search']"><i class="fa fa-gavel"></i> <span class="nav-label">Railcar Profile Mgmt</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/shopportal/usermanagement')}">
								<a [routerLink]="['/fleet/shopportal/usermanagement']"><i class="fa fa-users"></i> <span class="nav-label">User Mgmt</span></a>
							</li>				
						</ul>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('fleet/repairtemplate')}">  
						<a target="_blank" class="has-arrow"><i class="fa fa-book"></i> <span class="nav-label">Template Repair
							Management</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							<li [ngClass]="{'mm-active': activeRoute('fleet/repairtemplate/search')}">
								<a [routerLink]="['/fleet/repairtemplate/search']"><i class="fa fa-book"></i> <span class="nav-label">Template Repair
									Management</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/repairtemplate/jobCodeMaintenance')}">
								<a [routerLink]="['/fleet/repairtemplate/jobCodeMaintenance']"><i class="fa fa-book"></i> <span class="nav-label">Job code Maintenance</span></a>
							</li>
						
						</ul>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('fleet/report')}">  
						<a target="_blank" class="has-arrow"><i class="fa fa-chart-line"></i> <span class="nav-label">Reporting</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/crbExport')}">
								<a [routerLink]="['/fleet/report/crbExport']"><i class="fa fa-file"></i> <span class="nav-label">500 Byte File Export</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/repairAccrual')}">
								<a [routerLink]="['/fleet/report/repairAccrual']"><i class="fa fa-file"></i> <span class="nav-label">Repair Accrual Report</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/ownerCrb500ByteFile')}">
								<a [routerLink]="['/fleet/report/ownerCrb500ByteFile']"><i class="fa fa-file"></i> <span class="nav-label">Owner CRB 500 File Report</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/wheelReport')}">
								<a [routerLink]="['/fleet/report/wheelReport']"><i class="fa fa-chart-bar"></i> <span class="nav-label">Wheel Report</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/customerApprovalsReport')}">
								<a [routerLink]="['/fleet/report/customerApprovalsReport']"><i class="fa fa-chart-line"></i> <span class="nav-label">Customer Approvals</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/soldcar500bReport')}">
								<a [routerLink]="['/fleet/report/soldcar500bReport']"><i class="fa fa-file"></i> <span class="nav-label">Sold Car 500B CRB Export</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/programworkReport')}">
								<a [routerLink]="['/fleet/report/programworkReport']"><i class="fa fa-file"></i> <span class="nav-label">Program Work</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/railincFiles')}">
								<a [routerLink]="['/fleet/report/railincFiles']"><i class="fa fa-file"></i> <span class="nav-label">Railinc Files</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/remarkedCars')}">
								<a [routerLink]="['/fleet/report/remarkedCars']"><i class="fa fa-file"></i> <span class="nav-label">Remarked Cars</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/pbiReport')}">  
								<a target="_blank" class="has-arrow"><i class="fa fa-chart-bar"></i> <span class="nav-label">Fleet PBI Reports</span><span class="fa arrow"></span></a>
								<ul *ngIf="pbiFleetRpts" class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']" style="overflow-y: auto;"> 
									<li *ngFor="let rpt of pbiFleetRpts" [ngClass]="{'mm-active': activeRoute('pbiReport', rpt.reportGuid)}">
										<a [routerLink]="['/fleet/report/pbiReport']" [queryParams]="{id: rpt.reportGuid}"> <i class="fa fa-file"></i> <span class="nav-label">{{rpt.reportName}}</span></a>
									</li> 
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</li>
			<li *ngIf="sfhAuth.isAuthenticated() && userInfo && sfhAuth.hasPermissions('commercial')" [ngClass]="{'mm-active': activeRoute('commercial')}">
				<a target="_blank" class="has-arrow"><i class="fa fa-users"></i> <span class="nav-label">Commercial</span><span class="fa arrow"></span></a>
				<ul class="nav nav-second-level mm-collapse" [routerLinkActive]="['mm-show']">
					<li [ngClass]="{'mm-active': activeRoute('customer/search')}">
						<a [routerLink]="['/commercial/customer/search']"><i class="fa fa-user-circle"></i><span class="nav-label">Customer</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('lease/search')}">
						<a [routerLink]="['/commercial/lease/search']"><i class="fa fa fa-handshake"></i><span class="nav-label">Lease</span></a>
					</li>					
					<li [ngClass]="{'mm-active': activeRoute('railcar')}">
						<a target="_blank" class="has-arrow"><i class="fa fa-train"></i> <span class="nav-label">Railcar</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							<li [ngClass]="{'mm-active': activeRoute('commercial/railcar/search')}">
								<a [routerLink]="['/commercial/railcar/search']" class="has-arrow"><i class="fa fa-train"></i><span class="nav-label">Railcar</span></a>
							</li>
							<li *ngIf="sfhAuth.isAuthenticated() && userInfo && sfhAuth.hasPermissions('canAddRailcar')" [ngClass]="{'mm-active': activeRoute('commercial/railcar/createRailcars')}">
								<a [routerLink]="['/commercial/railcar/createRailcars']"><i class="fa fa-plus-circle"></i> <span class="nav-label">Add Railcars</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/railcar/ownership/search')}">
								<a [routerLink]="['/commercial/railcar/ownership/search']"><i class="fa fa-address-card"></i><span class="nav-label">Ownership</span></a>
							</li>
							<li *ngIf="sfhAuth.isAuthenticated() && userInfo && sfhAuth.hasPermissions('CanAddRailcarAttribute')" [ngClass]="{'mm-active': activeRoute('commercial/railcar/assetProfileAttributeUpdate')}">
								<a [routerLink]="['/commercial/railcar/assetProfileAttributeUpdate']"><i class="fa fa-sliders-h"></i><span class="nav-label">Asset Profile Attribute Update</span></a>
							</li>
						</ul>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('trackandtrace/search')}">
						<a [routerLink]="['/commercial/trackandtrace/search']"><i class="fa fa-map-pin"></i><span class="nav-label">Track & Trace</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('carhire/search')}">
						<a [routerLink]="['/commercial/carhire/search']"><i class="fa fa-tachometer-alt"></i><span class="nav-label">Car Hire</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('documents/search')}">
						<a [routerLink]="['/commercial/documents/search']"><i class="fa fa-file-alt"></i><span class="nav-label">Railcar Docs</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('report')}">
						<a target="_blank" class="has-arrow"><i class="fa fa-chart-line"></i> <span class="nav-label">Reporting</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/leaseProjection')}">
								<a [routerLink]="['/commercial/report/leaseProjection']"><i class="fa fa-tasks"></i> <span class="nav-label">Lease Projection</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/leaseSummaryByCube')}">
								<a [routerLink]="['/commercial/report/leaseSummaryByCube']"><i class="fa fa-tasks"></i> <span class="nav-label">Lease Summary By Cube</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/leaseList')}">
								<a [routerLink]="['/commercial/report/leaseList']"><i class="fa fa-tasks"></i> <span class="nav-label">Lease List Report</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/leaseOverrideContacts')}">
								<a [routerLink]="['/commercial/report/leaseOverrideContacts']"><i class="fa fa-tasks"></i> <span class="nav-label">Lease Override Contacts</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/baseRentalOwnership')}">
								<a [routerLink]="['/commercial/report/baseRentalOwnership']"><i class="fa fa-tasks"></i> <span class="nav-label">Base Rental Ownership Report</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/baseRentalCreditOverlap')}">
								<a [routerLink]="['/commercial/report/baseRentalCreditOverlap']"><i class="fa fa-tasks"></i> <span class="nav-label">Base Rental Credit Overlap</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/baseRentalOverlapReport')}">
								<a [routerLink]="['/commercial/report/baseRentalOverlapReport']"><i class="fa fa-tasks"></i> <span class="nav-label">Base Rental Overlap</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('fleet/report/baseRentalAudit')}">
								<a [routerLink]="['/fleet/report/baseRentalAudit']"><i class="fa fa-file"></i> <span class="nav-label">Base Rental Audit</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/baseRentalAdjustment')}">
								<a [routerLink]="['/commercial/report/baseRentalAdjustment']"><i class="fa fa-tasks"></i> <span class="nav-label">Base Rental Adjustments</span></a>
							</li>
							<!-- <li [ngClass]="{'mm-active': activeRoute('commercial/report/billingRentalAdjustment')}">
								<a [routerLink]="['/commercial/report/billingRentalAdjustment']"><i class="fa fa-tasks"></i> <span class="nav-label">Billing Rental Summary</span></a>
							</li> -->
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/storageAccural')}">
								<a [routerLink]="['/commercial/report/storageAccural']"><i class="fa fa-tasks"></i> <span class="nav-label">Storage Accrual</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/temporarilyOffLease')}">
								<a [routerLink]="['/commercial/report/temporarilyOffLease']"><i class="fa fa-tasks"></i> <span class="nav-label">Temporarily Off Lease</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/customerRevenueByDateRangeReport')}">
								<a [routerLink]="['/commercial/report/customerRevenueByDateRangeReport']"><i class="fa fa-tasks"></i> <span class="nav-label">Customer Revenue by Date Range</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('commercial/report/pbiReport')}">  
								<a target="_blank" class="has-arrow"><i class="fa fa-chart-bar"></i> <span class="nav-label">Commercial PBI Reports</span><span class="fa arrow"></span></a>
								<ul *ngIf="pbiCommercialRpts" class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']" style="overflow-y: auto;"> 
									<li *ngFor="let rpt of pbiCommercialRpts" [ngClass]="{'mm-active': activeRoute('pbiReport', rpt.reportGuid)}">
										<a [routerLink]="['/commercial/report/pbiReport']" [queryParams]="{id: rpt.reportGuid}"> <i class="fa fa-file"></i> <span class="nav-label">{{rpt.reportName}}</span></a>
									</li> 
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</li>
			<li *ngIf="sfhAuth.isAuthenticated()" [ngClass]="{'mm-active': activeRoute('invoice')}">
				<a target="_blank" class="has-arrow"><i class="fa fa-dollar-sign"></i> <span class="nav-label">Invoices</span><span class="fa arrow"></span></a>
				<ul class="nav nav-second-level mm-collapse" [routerLinkActive]="['mm-show']">
					<li [ngClass]="{'mm-active': activeRoute('inbox')}"> 
						<a [routerLink]="['/inboxinvoice']"><i class="fa fa-envelope"></i><span class="nav-label">Shop Est/Inv Inbox</span></a>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('invoice/audit')}">
						<a [routerLink]="['/carrepairbilling/invoice/audit']"><i class="fa fa-exclamation-triangle"></i><span class="nav-label">Audit</span></a>
					</li>
					<li *ngIf="sfhAuth.isAuthenticated()" [ngClass]="{'mm-active': activeRoute('invoice/ap')}">
						<a target="_blank" class="has-arrow"><i class="fa fa-dollar-sign"></i> <span class="nav-label">AP Invoices</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							<li [ngClass]="{'mm-active': activeRoute('/carrepairbilling/invoice/ap')}">
								<a [routerLink]="['/carrepairbilling/invoice/ap']"><i class="fa fa-gavel"></i><span class="nav-label">Repair</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/storage/invoice/ap')}">
								<a [routerLink]="['/storage/invoice/ap']"><i class="fa-light fa-exclamation"><i class="fa-light fa-exclamation" style="margin-right: 0px;"></i></i><span class="nav-label">Storage/Switch</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/freight/invoice/ap')}">
								<a [routerLink]="['/freight/invoice/ap']"><i class="fa fa-road"></i><span class="nav-label">Freight</span></a>
							</li>
						</ul>
					</li>
					<li [ngClass]="{'mm-active': activeRoute('invoice/ar')}">
						<a target="_blank" class="has-arrow"><i class="fa fa-dollar-sign"></i><span class="nav-label">AR Invoices</span><span class="fa arrow"></span></a>
						<ul class="nav nav-third-level mm-collapse" [routerLinkActive]="['mm-show']">
							
							<li [ngClass]="{'mm-active': activeRoute('/carrepairbilling/invoice/ar')}">
								<a [routerLink]="['/carrepairbilling/invoice/ar']"><i class="fa fa-gavel"></i><span class="nav-label">Repair</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/baserental/invoice/ar')}">
								<a [routerLink]="['/baserental/invoice/ar']"><i class="fa-light fa-exclamation"><i class="fa-light fa-exclamation"></i></i><span class="nav-label">Base Rental</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/storage/invoice/ar')}">
								<a [routerLink]="['/storage/invoice/ar']"><i class="fa-light fa-exclamation"><i class="fa-light fa-exclamation"></i></i><span class="nav-label">Storage</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/freight/invoice/ar')}">
								<a [routerLink]="['/freight/invoice/ar']"><i class="fa fa-road"></i><span class="nav-label">Freight/Switch</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/carhire/invoice/ar')}">
								<a [routerLink]="['/carhire/invoice/ar']"><i class="fa fa-tachometer-alt"></i><span class="nav-label">Car Hire</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/carhire/invoice/excessMileage')}">
								<a [routerLink]="['/carhire/invoice/excessMileage']"><i class="fa fa-road"></i><span class="nav-label">Excess Mileage</span></a>
							</li>
							<li [ngClass]="{'mm-active': activeRoute('/tankcarequalization/invoice/ar')}">
								<a [routerLink]="['/tankcarequalization/invoice/ar']"><i class="fa fa-road"></i><span class="nav-label">Tank Car Equalization</span></a>
							</li>
						</ul>
					</li>
				</ul>
			</li>
			<li *ngIf="sfhAuth.isAuthenticated() && userInfo && sfhAuth.hasPermissions('admin')" [ngClass]="{'mm-active': activeRoute('admin')}">
				<a target="_blank" class="has-arrow"><i class="fa fa-cogs"></i> <span class="nav-label">Admin</span><span class="fa arrow"></span></a>
				<ul class="nav nav-second-level mm-collapse" [routerLinkActive]="['mm-show']">
					<li [ngClass]="{'mm-active': activeRoute('admin/serviceEventLookup')}">
						<a [routerLink]="['/admin/serviceEventLookup']"><i class="fa fa-wrench"></i><span class="nav-label">Service Event lookup</span></a>
					</li>
				</ul>
			</li>
			<li>
				<a target="_blank" class="has-arrow"><i class="fa fa-question"></i><span class="nav-label">Help</span><span class="fa arrow"></span></a>
				<ul class="nav nav-second-level mm-collapse" [routerLinkActive]="['mm-show']">
					<li >
						<a href="https://sfhsinc.atlassian.net/servicedesk/customer/portal/3" target="_blank"><i class="fa fa-comment-dots"></i> <span class="nav-label">Submit a Request</span></a>
					</li>
					<li>
						<a href="https://sfhsinc.atlassian.net/servicedesk/customer/user/requests?page=1&reporter=all&statuses=open" target="_blank"><i class="fa fa-list-alt"></i><span class="nav-label">View Requests</span></a>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</nav>

<div class="overlay" style="z-index: 6000;" *ngIf="showNotifications">
	<div class="pull-right close-notifications" style="cursor: pointer;" (click)="toggleNotifications()">X</div>
	<notification-layout
		[notificationCategories]="notificationCategories"
		(closeNotifications)="toggleNotifications()">
	</notification-layout>
</div>
